import { render, staticRenderFns } from "./BeneficiariesView.vue?vue&type=template&id=30f3b9e5&scoped=true&"
import script from "./BeneficiariesView.vue?vue&type=script&lang=js&"
export * from "./BeneficiariesView.vue?vue&type=script&lang=js&"
import style0 from "@/assets/styles/beneficiary.css?vue&type=style&index=0&id=30f3b9e5&scoped=true&lang=css&"
import style1 from "@/assets/styles/beneficiary.css?vue&type=style&index=1&id=30f3b9e5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30f3b9e5",
  null
  
)

export default component.exports